var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_return",
    "data-name": "icon - return",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2868",
    "data-name": "Path 2868",
    d: "M17.354,2.154V.782A.784.784,0,0,0,16.571,0H.783A.784.784,0,0,0,0,.782V2.154ZM8.656,8.71a1.519,1.519,0,0,0-1.511,1.511,1.884,1.884,0,0,0,.112.569,1.511,1.511,0,0,0-.136,2.747H.783A.783.783,0,0,1,0,12.755V3.2H17.354V7.481L17.206,7.4a5.359,5.359,0,0,0-2.576-.662H10.482A1.511,1.511,0,0,0,9.039,8.7Zm4.278,1.048a.524.524,0,0,0,0-1.048H10.482a.463.463,0,1,1,0-.925H14.63a4.3,4.3,0,0,1,2.07.532l.967.533A5.225,5.225,0,0,0,20.18,9.5h1.669a.151.151,0,0,1,.151.15v3.27a.151.151,0,0,1-.151.15H20.1a5.174,5.174,0,0,0-1.85.34l-2.486.945a4.274,4.274,0,0,1-1.525.28H8.656a.463.463,0,1,1,0-.926h4.278a.524.524,0,1,0,0-1.048H7.814a.463.463,0,1,1,0-.926h5.12a.524.524,0,1,0,0-1.047H8.656a.463.463,0,1,1,0-.926Z",
    transform: "translate(3 6.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturn);
export default __webpack_public_path__ + "static/media/icon-return.526261f095c08ad8b4994b7e08efc450.svg";
export { ForwardRef as ReactComponent };